module.exports = __webpack_public_path__ + "img/result-y6.e08706ba.png";